/* Aurelight cart drawer — open/close + add via Shopify cart API + section re-render */
(function () {
  'use strict';
  const drawer = () => document.querySelector('[data-cart-drawer]');
  const overlay = () => document.querySelector('[data-cart-overlay]');
  const cartCount = () => document.querySelector('#cart-count');
  const drawerCount = () => document.querySelector('[data-drawer-count]');
  const totalEl = () => document.querySelector('[data-cart-total]');
  const checkout = () => document.querySelector('[data-checkout-btn]');
  const toast = () => document.querySelector('[data-toast]');
  const toastText = () => document.querySelector('[data-toast-text]');

  let toastTimer;
  function showToast(msg) {
    const t = toast();
    if (!t) return;
    toastText().textContent = msg;
    t.classList.add('show');
    clearTimeout(toastTimer);
    toastTimer = setTimeout(() => t.classList.remove('show'), 2400);
  }

  function open() {
    drawer()?.classList.add('open');
    overlay()?.classList.add('open');
    drawer()?.setAttribute('aria-hidden', 'false');
    document.body.style.overflow = 'hidden';
  }
  function close() {
    drawer()?.classList.remove('open');
    overlay()?.classList.remove('open');
    drawer()?.setAttribute('aria-hidden', 'true');
    document.body.style.overflow = '';
  }

  async function fetchCart() {
    const res = await fetch('/cart.js', { headers: { Accept: 'application/json' } });
    return res.json();
  }

  async function refreshDrawer() {
    try {
      const res = await fetch(window.location.pathname + '?sections=aurelight-cart-drawer', {
        headers: { Accept: 'application/json' },
      });
      const json = await res.json();
      const html = json['aurelight-cart-drawer'];
      if (!html) return;
      const tmp = document.createElement('div');
      tmp.innerHTML = html;
      const newBody = tmp.querySelector('[data-cart-body]');
      const newTotal = tmp.querySelector('[data-cart-total]');
      const newDrawerCount = tmp.querySelector('[data-drawer-count]');
      const newCheckout = tmp.querySelector('[data-checkout-btn]');
      const oldBody = document.querySelector('[data-cart-body]');
      if (newBody && oldBody) oldBody.innerHTML = newBody.innerHTML;
      if (newTotal && totalEl()) totalEl().textContent = newTotal.textContent;
      if (newDrawerCount && drawerCount()) drawerCount().textContent = newDrawerCount.textContent;
      if (newCheckout && checkout()) {
        checkout().setAttribute('style', newCheckout.getAttribute('style') || '');
      }
    } catch (e) {
      console.error('[aurelight-cart] section refresh failed', e);
    }
    const cart = await fetchCart().catch(() => null);
    if (cart && cartCount()) cartCount().textContent = cart.item_count;
  }

  async function addToCart(form) {
    const fd = new FormData(form);
    const btn = form.querySelector('[data-atc-button]');
    const originalLabel = btn?.textContent;
    if (btn) {
      btn.disabled = true;
      btn.textContent = 'Adding…';
    }
    try {
      const res = await fetch('/cart/add.js', {
        method: 'POST',
        body: fd,
        headers: { Accept: 'application/json' },
      });
      const data = await res.json();
      if (!res.ok) {
        showToast(data.description || 'Could not add to bag');
        if (btn) {
          btn.disabled = false;
          btn.textContent = originalLabel;
        }
        return;
      }
      showToast('Added to bag · ' + (data.product_title || 'Item'));
      if (btn) {
        btn.textContent = 'Added ✓';
        btn.style.background = 'var(--cyan)';
        btn.style.color = 'var(--black)';
        setTimeout(() => {
          btn.textContent = originalLabel;
          btn.style.background = '';
          btn.style.color = '';
          btn.disabled = false;
        }, 1800);
      }
      await refreshDrawer();
      open();
    } catch (e) {
      showToast('Network error — try again');
      if (btn) {
        btn.disabled = false;
        btn.textContent = originalLabel;
      }
    }
  }

  async function removeLine(key) {
    await fetch('/cart/change.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
      body: JSON.stringify({ id: key, quantity: 0 }),
    });
    await refreshDrawer();
  }

  document.addEventListener('click', (e) => {
    if (e.target.closest('[data-cart-toggle]')) {
      e.preventDefault();
      open();
      return;
    }
    if (e.target.closest('[data-cart-close]') || e.target.matches('[data-cart-overlay]')) {
      close();
      return;
    }
    const removeBtn = e.target.closest('[data-cart-remove]');
    if (removeBtn) {
      removeLine(removeBtn.dataset.cartRemove);
    }
  });

  document.addEventListener('submit', (e) => {
    const form = e.target.closest('[data-pdp-form]');
    if (!form) return;
    e.preventDefault();
    addToCart(form);
  });

  document.addEventListener('keydown', (e) => {
    if (e.key === 'Escape') close();
  });
})();
